import React from "react";
import "./Video.scss";

// ✅ Material UI Icons
import HtmlIcon from "@mui/icons-material/Html";
import CssIcon from "@mui/icons-material/Css";
import JavascriptIcon from "@mui/icons-material/Javascript";

// ✅ React Icons
import { IoLogoReact } from "react-icons/io5";
import { FaNodeJs } from "react-icons/fa";
import { DiMongodb, DiPython } from "react-icons/di";
import { SiExpress } from "react-icons/si";

const techIcons = [
  { id: 1, icon: <HtmlIcon />, color: "#E44D26", label: "HTML" },
  { id: 2, icon: <CssIcon />, color: "#1572B6", label: "CSS" },
  { id: 3, icon: <JavascriptIcon />, color: "#F7DF1E", label: "JavaScript" },
  { id: 4, icon: <IoLogoReact />, color: "#61DAFB", label: "React" },
  { id: 5, icon: <FaNodeJs />, color: "#3C873A", label: "Node.js" },
  { id: 6, icon: <SiExpress />, color: "#000000", label: "Express" },
  { id: 7, icon: <DiMongodb />, color: "#4DB33D", label: "MongoDB" },
  { id: 8, icon: <DiPython />, color: "#FFD43B", label: "Python" },
];

const Video = () => {
  return (
    <section className="video-section">
      <div className="section-header">
        <h2>Development Tools</h2>
        <p>Technologies we use to build efficient and modern applications.</p>
      </div>

      <div className="tech-grid">
        {techIcons.map((item) => (
          <div className="tech-card" key={item.id}>
            <div className="icon" style={{ color: item.color }}>
              {item.icon}
            </div>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Video;
